export const detachedHeaderParams = {
  b64: false,
  crit: ['b64'],
};
